"use strict";

import { dataUploadConstants } from "../_constants";

export const INITIAL_DATA_UPLOAD_STATE = {
     dataTemplate: [],
     dataUploadAdd: {
          isSuccess: false,
     },
     dataUploadList: [],
     dataUploadSummery: [],
     dataFileTypeList: [],
     dataFileSchemaList: [],
     RecordsCountData: "",
};

export function dataUpload(state = INITIAL_DATA_UPLOAD_STATE, action) {
     switch (action.type) {
          case dataUploadConstants.DATA_UPLOAD_DATA_TEMPLATE_LIST_COMPLETE:
               return {
                    ...state,
                    dataTemplate: action.payload,
               };
          case dataUploadConstants.DATA_UPLOAD_ADD_REQUEST:
               return {
                    ...state,
                    dataUploadAdd: {
                         isSuccess: false,
                    },
               };
          case dataUploadConstants.DATA_UPLOAD_ADD_COMPLETE:
               return {
                    ...state,
                    dataUploadAdd: {
                         isSuccess: true,
                    },
               };
          case dataUploadConstants.DATA_UPLOAD_LIST_COMPLETE:
               return {
                    ...state,
                    dataUploadList: action.payload,
               };

          case dataUploadConstants.DATA_UPLOAD_LIST_SILENT_COMPLETE:
               return {
                    ...state,
                    dataUploadList: action.payload,
               };
          case dataUploadConstants.DATA_UPLOAD_SUMMERY_COMPLETE:
               return {
                    ...state,
                    dataUploadSummery: action.payload,
               };
          case dataUploadConstants.DATA_UPLOAD_DATA_PROCESSING_RECORD_COMPLETE:
               return {
                    ...state,
                    dataUploadSummery: action.payload,
               };
          case dataUploadConstants.DATA_FILE_TYPE_LIST_COMPLETE:
               return {
                    ...state,
                    dataFileTypeList: action.payload,
               };
          case dataUploadConstants.DATA_FILE_SCHEMA_COMPLETE:
               return {
                    ...state,
                    RecordsCountData: "",
                    dataFileSchemaList: action.payload,
               };

          case dataUploadConstants.DATA_UPLOAD_RECORD_COUNT_COMPLETE:
               return {
                    ...state,
                    RecordsCountData: action.payload,
               };

          case dataUploadConstants.DATA_UPLOAD_LIST_REPRESH_REAL_TIME:
               return {
                    ...state,
                    dataUploadList: {
                         ...state.dataUploadList,
                         recordsList: [
                              ...state.dataUploadList.recordsList.map(
                                   (data) => {
                                        if (action.payload.Id == data.id) {
                                             data.status =
                                                  action.payload.Status;
                                        }

                                        return data;
                                   },
                              ),
                         ],
                    },
               };
     }

     return state;
}
